import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LmsConfig } from '@models/lmsConfig';
import * as Sentry from '@sentry/angular';
import { BrowserTracing } from '@sentry/tracing';
import { map } from 'rxjs/operators';

const prodServerHost = '10.206.0.23';
const prodServerPort = '8899';

@Injectable({ providedIn: 'root' })
export class EnvConfigurationService {
  public config: LmsConfig = {
    lmsApiUrl: '',
    clientSentryDsn: '',
    releaseType: 'LOCAL',
  };
  public appSettingsUrl = 'assets/appSettings/lmsAppSettings.json';
  constructor(private http: HttpClient) {}

  get releaseType() {
    return this.config === null ? 'LOCAL' : this.config.releaseType;
  }

  public load(): Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
      this.http
        .get<LmsConfig>(this.appSettingsUrl)
        .pipe(map((config) => config))
        .subscribe({
          next: (config) => {
            this.config = config;
            this.changeApiURLForInternalConnection();

            // get version from api and then init sentry using dsn from config
            this.http
              .get<any>('info')
              .pipe(map((version) => version))
              .subscribe({
                next: (version) => {
                  Sentry.init({
                    dsn: config.clientSentryDsn,
                    integrations: [
                      new BrowserTracing({
                        tracingOrigins: [config.lmsApiUrl.split('/api')[0]],
                        routingInstrumentation: Sentry.routingInstrumentation,
                      }),
                    ],

                    // sample rate 100% in LOCAL environment but 20% in all other environments
                    tracesSampleRate:
                      config.releaseType === 'LOCAL'
                        ? 0.0
                        : config.releaseType === 'PROD'
                        ? 0.2
                        : 1,
                    release: version.data,
                    environment: config.releaseType,
                  });
                  resolve(true);
                },
                error: (err) => reject(err),
              });
          },
          error: (err) => reject(err),
        });
    });
  }

  private changeApiURLForInternalConnection() {
    if (
      this.config.releaseType === 'PROD' &&
      window.location.hostname === prodServerHost
    ) {
      this.config.lmsApiUrl = `http://${prodServerHost}:${prodServerPort}/api/v1`;
    }
  }
}
